import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteHomework } from '@services/registry';

export function useDeleteHomework({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ homeworkId }) => {
            return await deleteHomework({ tenantId, homeworkId });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['homeworks', tenantId] });
        },
    });
}
